$.fn.valueTrimmed = function () {
    return $(this).val().trim();
};

function fieldIsEmpty(fieldValue) {
    return fieldValue == null || fieldValue.length === 0;
}

function fieldIsNotEmpty(fieldValue) {
    return !fieldIsEmpty(fieldValue);
}

function fieldIsEmail(fieldValue) {
    return fieldValue != null && is_email(fieldValue);
}

let emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

function is_email(email) {
    return emailReg.test(email);
}


$.fn.validateIf = function (condition) {
    this.invalidateIf(!condition);
};

$.fn.invalidateIf = function (condition) {
    let formGroup = this.parent();
    if (condition) {
        formGroup.addClass('has-error');
        this.attr('placeholder', 'required');
    } else {
        formGroup.removeClass('has-error');
    }
};

